import { ICorporatePartner } from './corporate-partner.interface';

export class DefaultDisplay implements ICorporatePartner {
  public name = 'default';
  public displayBusinessLogo = false;
  public updateBgColor = false;
  public restrictPaxToOne = false;
  public disableMiles = false;
  public displayInlineText = 'default';
  public showPopupForEcert = false;
  public showBusinessText = false;
  public showBusinessMilesLabel = false;
}
